/**
 * KB-META
 * Purpose: App sidebar
 * Role: ui.component
 * EntryPoints: constructor(), onRoleChange(), viewAll(), resetRole()
 * Inputs: public el:ElementRef; roles:RoleLevel[]
 * Outputs: 
 * Validation: 
 * Dependencies: ElementRef
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=component/app.sidebar; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Component, ElementRef, inject } from '@angular/core';
import { AppMenu } from './app.menu';
import { CommonModule } from '@angular/common';
import { ENV as environment } from '../../config/environment';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { RoleLevel } from './roles';
import { RoleOverrideService } from './role-override.service';

@Component({
    selector: 'app-sidebar',
    standalone: true,
    imports: [AppMenu, CommonModule, DropdownModule, FormsModule],
    template: `
    <div class="layout-sidebar">
        <div *ngIf="showRoleSwitcher" class="role-switcher" style="padding:8px;">
            <p-dropdown [options]="roleOptions" placeholder="View as role" [(ngModel)]="selectedRole" (onChange)="onRoleChange($event.value)"></p-dropdown>
            <div style="margin-top:8px; display:flex; gap:8px;">
              <button type="button" class="p-button p-button-sm" (click)="viewAll()">All</button>
              <button type="button" class="p-button p-button-sm p-button-secondary" (click)="resetRole()">Reset</button>
            </div>
        </div>
        <app-menu></app-menu>
    </div>`
})
export class AppSidebar {
    env = environment as any;
    private roleOverride = inject(RoleOverrideService);
    selectedRole: RoleLevel[] | null = null;
    get showRoleSwitcher(): boolean { return this.env && this.env.enableRoleSwitcher !== false; }
    roleOptions = [
      {label:'Clinician (1)', value:[RoleLevel.CLINICIAN]},
      {label:'Content Manager (2)', value:[RoleLevel.CONTENT_MANAGER]},
      {label:'Partner Admin (3)', value:[RoleLevel.PARTNER_ADMIN]},
      {label:'Security Admin (4)', value:[RoleLevel.SECURITY_ADMIN]},
      {label:'Analytics Admin (5)', value:[RoleLevel.ANALYTICS_ADMIN]},
      {label:'Support Agent (6)', value:[RoleLevel.SUPPORT_AGENT]},
      {label:'Auditor (Read-only) (7)', value:[RoleLevel.AUDITOR_READONLY]},
      {label:'Super Admin (0)', value:[RoleLevel.SUPER_ADMIN]},
    ];
    constructor(public el: ElementRef) {}
    onRoleChange(roles: RoleLevel[]) { this.roleOverride.set(roles); }
    viewAll() { this.roleOverride.set([RoleLevel.ALL]); }
    resetRole() { this.roleOverride.set(null); }
}
